







































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { PaymentInfoModel, InstallmentModel } from '@/app/shared/models';
import { DataTableHeader } from 'vuetify';
import DialogInstallmentDetails from '@/app/shared/components/dialogs/installment-details.vue';
import DataTableAttempts from '@/app/shared/components/data-tables/attempts.vue';
import ContentPaymentInfo from '@/app/shared/components/contents/payment-info.vue';
@Component({
  components: {
    DataTableAttempts,
    ContentPaymentInfo,
    DialogInstallmentDetails,
  },
})
export default class DialogChargebackDetailsComponent extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  private headers: DataTableHeader[] = [];
  private loading = false;
  private dialog = false;

  private get refs() {
    return refsService;
  }
  private get installment() {
    return this.refs.modules.contract.installment;
  }
  private get installmentPaymentInfo() {
    return this.refs.modules.contract.installmentPaymentInfo;
  }

  private get History() {
    return this.refs.modules.contract.chargebackHistoryList;
  }

  private created(): void {
    this.headers = [
      { text: this.$t('headers.status').toString(), value: 'Status' },
      {
        text: this.$t('headers.installment').toString(),
        value: 'Number',
      },
      {
        text: this.$t('headers.type').toString(),
        value: 'InstallmentType',
      },
      {
        text: this.$t('headers.attempts').toString(),
        value: 'CurrentAttemptNumber',
      },
      {
        text: this.$t('headers.integration_identifier').toString(),
        value: 'OurCode',
      },
      {
        text: this.$t('headers.installment_maturity').toString(),
        value: 'OriginalDueDate',
      },
      {
        text: this.$t('headers.reference').toString(),
        value: 'Reference',
      },
      {
        text: this.$t('labels.payment_method').toString(),
        value: 'PaymentInfos',
      },
      { text: this.$t('headers.value').toString(), value: 'Value' },
      { text: '', value: 'Actions', sortable: false, align: 'end' },
    ];
  }

  private paymentInfo(paymentInfos: PaymentInfoModel[]) {
    let result = '';
    paymentInfos.map((paymentInfo) => {
      if (paymentInfo) {
        if (result) {
          result += '<br/>';
        }
        if (
          this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod] ==
          this.refs.enums.PaymentMethod.Debit.toString()
        )
          result += `Ag. ${
            paymentInfo.BranchNumber && paymentInfo.BranchDigit
              ? `${paymentInfo.BranchNumber}-${paymentInfo.BranchDigit}`
              : paymentInfo.BranchNumber || paymentInfo.BranchDigit || '--'
          }
        <br />Cc. ${
          paymentInfo.AccountNumber && paymentInfo.AccountDigit
            ? `${paymentInfo.AccountNumber}-${paymentInfo.AccountDigit}`
            : paymentInfo.AccountNumber || paymentInfo.AccountDigit || '--'
        }`;
        else if (
          this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod] ==
            this.refs.enums.PaymentMethod.BankSlip.toString() ||
          this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod] ==
            this.refs.enums.PaymentMethod.BRCode.toString()
        ) {
          result = this.refs.static.enumDescriptions.get2(
            this.refs.enums.PaymentMethod,
            paymentInfo.PaymentMethod
          );
        } else if (
          this.refs.enums.PaymentMethod[paymentInfo.PaymentMethod] ==
          this.refs.enums.PaymentMethod.Credit.toString()
        )
          result += paymentInfo.CardTruncatedNumber || '--';
      }
    });
    return result;
  }

  private async loadInstallment(installment: InstallmentModel) {
    this.loading = true;
    this.$emit('close');
    installment.YearReference = installment.Reference?.Year;
    installment.MonthReference = installment.Reference?.Month;
    this.refs.modules.contract.SET_INSTALLMENT(installment);
    const paymentInfo = this.refs._.head(this.installment.PaymentInfos);
    if (paymentInfo)
      this.refs.modules.contract.SET_INSTALLMENT_PAYMENT_INFO(paymentInfo);
    this.refs.modules.contract
      .loadAttemptList({
        contractId: this.refs.modules.contract.contract.Id,
        installmentId: this.refs.modules.contract.installment.Id,
      })
      .then(() => this.$emit('open-detail'))
      .catch((err) => this.$toast.error('ERROR ? ', err))
      .finally(() => {
        this.loading = false;
      });
  }
}
